import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
}

const KlubQuoteIcon: NextPage<Props> = ({
  width = "100%",
  height = "100%",
  color = "#fff",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M12.1274 5.8344C11.5839 6.58174 11.0743 7.39703 10.5987 8.28025C10.1911 9.09554 9.81741 9.9448 9.47771 10.828C9.20594 11.6433 8.96815 12.4246 8.76433 13.172C8.56051 13.9193 8.4586 14.5308 8.4586 15.0064C8.4586 15.3461 8.52654 15.6858 8.66242 16.0255C8.7983 16.2972 9.138 16.4331 9.68153 16.4331C11.1762 16.4331 12.2633 17.0446 12.9427 18.2675C13.69 19.4904 14.0637 20.8832 14.0637 22.4459C14.0637 24.2803 13.4862 25.7749 12.3312 26.9299C11.2442 28.0849 9.64756 28.6624 7.5414 28.6624C2.5138 28.6624 0 26.2505 0 21.4268C0 20.0679 0.203822 18.6072 0.611465 17.0446C1.08705 15.482 1.66454 13.9193 2.34395 12.3567C3.0913 10.7261 3.90658 9.19745 4.78981 7.7707C5.67304 6.34395 6.52229 5.08705 7.33758 4L12.1274 5.8344ZM30.0637 5.8344C29.5202 6.58174 29.0106 7.39703 28.535 8.28025C28.1274 9.09554 27.7537 9.9448 27.414 10.828C27.1422 11.6433 26.9045 12.4246 26.7006 13.172C26.4968 13.9193 26.3949 14.5308 26.3949 15.0064C26.3949 15.3461 26.4628 15.6858 26.5987 16.0255C26.7346 16.2972 27.0743 16.4331 27.6178 16.4331C29.1125 16.4331 30.1996 17.0446 30.879 18.2675C31.6263 19.4904 32 20.8832 32 22.4459C32 24.2803 31.4225 25.7749 30.2675 26.9299C29.1805 28.0849 27.5839 28.6624 25.4777 28.6624C20.4501 28.6624 17.9363 26.2505 17.9363 21.4268C17.9363 20.0679 18.1401 18.6072 18.5478 17.0446C19.0234 15.482 19.6008 13.9193 20.2803 12.3567C21.0276 10.7261 21.8429 9.19745 22.7261 7.7707C23.6093 6.34395 24.4586 5.08705 25.2739 4L30.0637 5.8344Z"
        fill={color}
      />
    </svg>
  );
};

export default KlubQuoteIcon;
